module.exports = __webpack_public_path__ + "img/guohuali.9ddcf9b1.jpg";